module.exports = __webpack_public_path__ + "static/media/logo-mabd-trans.90d6a3e9.png";